import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { META_REDUCERS, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { JwtHelperService } from '@auth0/angular-jwt';
import { DelfiGuiAuthModule, DelfiUserProfileModule } from '@delfi-gui/components';
import { of } from 'rxjs';

import { routes } from './app.routes';
import { appReducers, appEffects } from './core/store';
import { localStorageMetaReducer } from './core/store/local-storage.meta-reducer';
import { LocalStorageService } from './core/services/local-storage.service';
import { MarketplaceDelfiAuthConfig } from './core/services/marketplace-delfi-auth.config';
import { retryLoggingInterceptor } from './core/interceptors/retry-logging.interceptor';
import { marketplaceTokenInterceptor } from './core/interceptors/marketplace-token.interceptor';
import { SpartacusProvidersModule } from './spartacus-providers.module';
import { SlbRedirectService } from 'app/core/services/slb-redirect.service';
import { SlbInlineMessageService } from 'app/core/services/slb-inline-message.service';

export const spartacusAppConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })),
    provideHttpClient(
      withInterceptors([retryLoggingInterceptor, marketplaceTokenInterceptor]),
      withInterceptorsFromDi(),
    ),
    importProvidersFrom(
      StoreModule.forRoot(appReducers),
      EffectsModule.forRoot([]),
      SpartacusProvidersModule,
      EffectsModule.forFeature(appEffects),
      DelfiUserProfileModule,
      DelfiGuiAuthModule.forRoot(MarketplaceDelfiAuthConfig),
    ),
    {
      provide: META_REDUCERS,
      useFactory: (svc: LocalStorageService) => localStorageMetaReducer(svc),
      deps: [LocalStorageService],
      multi: true,
    },
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),

    { provide: ActiveCartFacade, useValue: { takeActive: () => of({}) } },
    { provide: SlbRedirectService, useValue: { redirect: () => void 0, getBasePathName: () => of('') } },
    { provide: SlbInlineMessageService, useValue: { reset: () => void 0 } },
    { provide: JwtHelperService, useValue: new JwtHelperService() },
  ],
};
